module.exports = __webpack_public_path__ + "static/media/availability_banner.9ef03dd7.jpg";